import pluralize from 'pluralize';

angular.module('filters').filter('singularize', function() {
  return function(data) {
    return pluralize.singular(data);
  };
});
